import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const CTASection = () => {
  const auth = useAuth();

  return (
    <section className="py-5 bg-white">
      <div className="container">
        <div
          className="rounded-4 p-5 text-center position-relative overflow-hidden text-white"
          style={{
            background: "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)",
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
          }}
        >
          {/* Decorative circles */}
          <div
            className="position-absolute bg-white rounded-circle opacity-10"
            style={{ width: "300px", height: "300px", top: "-100px", left: "-100px", filter: "blur(50px)" }}
          />
          <div
            className="position-absolute bg-white rounded-circle opacity-05"
            style={{ width: "400px", height: "400px", bottom: "-150px", right: "-100px", filter: "blur(60px)" }}
          />

          <div className="position-relative z-1 mx-auto" style={{ maxWidth: "700px" }}>
            <h2 className="fw-bold display-5 mb-4">
              Bereit für stressfreie Familienwochen?
            </h2>
            <p className="fs-5 mb-5 text-white-50">
              Starte kostenlos und bringe Ordnung in euren Alltag. Keine Kreditkarte erforderlich.
            </p>

            <button
              className="btn btn-light btn-lg px-5 py-3 rounded-pill fw-bold d-inline-flex align-items-center gap-2 shadow"
              onClick={() => auth.login()}
            >
              Jetzt kostenlos starten
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
